export const sanitizeHost = (host: string) =>
	host.split('.')[0].replace('-workspace', '')
export const getHostEnv = (host: string) =>
	host.includes('dev-') || host.includes('localhost') ? 'staging' : 'production'
export const getHostProject = (host: string) => host.replace('dev-', '')
